import anti from "../assets/structures/anti-symmetric.png";
import beamsfail from "../assets/structures/beamsfail.png";
import beamsfail2 from "../assets/structures/beamsfail2.png";
import bridge from "../assets/structures/bridgedeck.png";
import bridge2 from "../assets/structures/bridgedeck2.png";
import cornersfail from "../assets/structures/cornerfailure.png";
import corners from "../assets/structures/corners.png";
import failureGFRPbeams from "../assets/structures/failureGFRPbeams.png";
import failureGFRPbeamsSTIRUPS from "../assets/structures/failureGFRPbeamsSTIRUPS.png";
import fea from "../assets/structures/FEAofslab.png";
import gfrpcasting from "../assets/structures/gfrpcagescasting.png";
import gfrpRE from "../assets/structures/gfrpreinforcement.png";
import gfrpRE2 from "../assets/structures/gfrpreinforcement2.png";
import model from "../assets/structures/modelofshearreinforce.png";
import flexure from "../assets/materials/flexure.png";
import compression from "../assets/materials/compression.png";
import shear from "../assets/materials/shear.png";
import tensile from "../assets/materials/tensile.png";

export default [
    anti,
    beamsfail,
    beamsfail2,
    bridge,
    bridge2,
    corners,
    cornersfail,
    failureGFRPbeams,
    failureGFRPbeamsSTIRUPS,
    fea,
    gfrpRE,
    gfrpRE2,
    gfrpcasting,
    model,
    flexure,
    compression,
    shear,
    tensile,
];
